export default __webpack_public_path__ + "static/thumb-landscape-2a9bed1efbc68de874c1c88bd7b8fc36.jpg";